export default __webpack_public_path__ + "static/media/KOD0083-min.0f87257c.webp";